<template>
  <Modal
    :active="isOpen"
    title="Histórico de Alterações"
    @close="closeModal"
    id="anti-fraud-config-history-modal"
  >
    <div class="modal-content no-scroll-x">
      <vs-table
        v-if="historyData.length"
        :data="historyData"
        class="history-table"
      >
        <template slot="thead">
          <vs-th>Data Alteração</vs-th>
          <vs-th>Responsável</vs-th>
          <vs-th>Campo</vs-th>
          <vs-th>Valor Anterior</vs-th>
          <vs-th>Novo Valor</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr v-for="row in data" :key="row.id">
            <vs-td class="w-2/12">{{ formatDate(row.createdAt) }}</vs-td>
            <vs-td class="w-2/12">{{ row.username }}</vs-td>

            <vs-td class="w-2/12">
              {{ translateField(row.field) }}
            </vs-td>

            <vs-td class="w-3/12">
              {{ translateValue(row.field, row.oldValue) }}
            </vs-td>

            <vs-td class="w-3/12">
              {{ translateValue(row.field, row.newValue) }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <p v-else>Nenhum dado encontrado.</p>
    </div>
  </Modal>
</template>

<script>
import Modal from '../../../../components/Modal.vue';
import antiFraudApiService from '../../../../services/anti.fraud.api';
import functions from '../../../../utils/functions';

export default {
  name: 'AntiFraudConfigHistoryModal',
  components: { Modal },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    antiFraudConfigId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      historyData: [],
      fieldTranslations: {
        active: 'Ativo',
        products: 'Produtos',
        authenticationType: 'Tipo de Autenticação',
        baseUrl: 'URL Base',
        username: 'Usuário PF',
        usernameAlt: 'Usuário PJ',
        secret: 'Chave Secreta',
        secretAlt: 'Chave Secreta PJ',
        flowName: 'Nome do Fluxo',
        executionStageCode: 'Executar em',
        path: 'Caminho',
        updatedAt: 'Última Alteração',
        createdAt: 'Data de Criação',
      },
      valueTranslations: {
        true: 'Sim',
        false: 'Não',
        key: 'Chave de API',
        auth: 'Usuário e Senha',
      },
      jsonKeyTranslations: {
        active: 'Ativo',
        rules: 'Regras',
        score: 'Score',
        insights: 'Insights',
        ratings: 'Ratings',

        newPolicyAndEndorsement: 'Nova Apólice / Endosso',
        oneTimePayment: 'Pagamento Único',

        autoReject: 'Reprovação Automática',
        manualReview: 'Revisão Manual',
        autoApprove: 'Aprovação Automática',

        from: 'De',
        to: 'Até',
      },
    };
  },
  watch: {
    isOpen(opened) {
      if (opened) {
        this.fetchHistory();
      } else {
        this.historyData = [];
      }
    },
  },
  methods: {
    async fetchHistory() {
      if (!this.antiFraudConfigId) return;

      try {
        const response = await antiFraudApiService.getAntiFraudConfigHistory(
          this.antiFraudConfigId,
        );

        this.historyData = response || [];
      } catch {
        this.$vs.notify({
          position: 'top-center',
          title: 'Erro',
          text: 'Erro ao carregar histórico de alterações.',
          color: 'danger',
        });
      }
    },
    translateValue(field, value) {
      if (!value) return '—';

      if (field === 'products') {
        return this.translateJsonValue(value);
      }

      if (this.valueTranslations[value]) {
        return this.valueTranslations[value];
      }

      return value;
    },

    translateJsonValue(value) {
      try {
        const parsed = JSON.parse(value);
        const translated = this.translateJsonKeys(parsed);
        return JSON.stringify(translated, null, 2);
      } catch {
        return value;
      }
    },

    translateJsonKeys(obj) {
      if (Array.isArray(obj)) {
        return obj.map(this.translateJsonKeys);
      }

      if (obj !== null && typeof obj === 'object') {
        return Object.keys(obj).reduce((acc, key) => {
          const translatedKey = this.jsonKeyTranslations[key] || key;
          acc[translatedKey] = this.translateJsonKeys(obj[key]);
          return acc;
        }, {});
      }

      return this.valueTranslations[obj] || obj;
    },

    closeModal() {
      this.historyData = [];
      this.$emit('close');
    },

    formatDate(date) {
      return functions.formataDataHoraPadraoBR(date, true);
    },

    translateField(field) {
      return this.fieldTranslations[field] || field;
    },
  },
};
</script>

<style>
#anti-fraud-config-history-modal.con-vs-popup .vs-popup {
  min-width: 880px;
  max-width: 1200px;
  width: auto;
}
.no-scroll-x {
  overflow-x: hidden;
}
.history-table {
  width: 100%;
  table-layout: fixed;
}
.history-table td,
.history-table th {
  white-space: normal;
  word-break: break-word;
}
</style>
